import PageIntro from "@/components/site/PageIntro";
import Services from "@/components/site/Services";
import Approach from "@/components/site/Approach";

export default function ServicesPage() {
  return (
    <div data-testid="services-page">
      <PageIntro
        overline="Services"
        title="What we do."
        subtitle="We keep your systems running and build the software that moves you forward — under one accountable roof."
      />
      <Services />
      <Approach />
    </div>
  );
}
